

























































import Vue from 'vue';
import { Component, Watch} from 'vue-property-decorator';
import reportModule from '@/store/modules/common/report.module';
import goalModule from '@/store/modules/common/goal.module'
import _ from 'lodash';
import VBarItem from '@/components/report/item/VBarItem.vue';
import { dateFilter2 } from '@/config/filter';
import VBarItemList from '@/components/report/item/VBarItemList.vue';
import Mixin from '@/mixin';
import reportViewModel from '@/views/mastercoach/reportViewModel';

@Component({
  name: 'ReportGroupIndividualChart',
  components: { VBarItemList, VBarItem }
})
export default class ReportGroupIndividualChart extends Mixin {

  public goalData: any = null

  public getReportDate(reportGroup: any) {
    if (reportModule.reportSorting !== 'goalId') {
      return reportGroup[reportModule.reportSorting];
    }
    if (
      reportGroup['reports'][0]['goalYear']
    ) {
      return (
        reportGroup['reports'][0]['goalYear']
      );
    } else return '#';
  }

  public getGoalContent(reportGroup: any) {
    if (reportModule.reportSorting !== 'goalId') {
      return '';
    }
    if (
      reportGroup['reports'][0]['goalContent']
    ) {
      return (
        reportGroup['reports'][0]['goalContent']
      );
    } else return '#';
  }

  public getGoalCompletion(reportGroup: any) {
    if (reportModule.reportSorting === 'goalId') {
      if (!this.goalData) return '';

      if (this.goalData) {
        return (
          (this.goalData[reportGroup['reports'][0]['goalId']] || '') + '%'
        );
      }
    } else return '';
  }

  public filterReport(data: any) {
    const reportData = _.chain(data)
      .orderBy(['fullCreated', 'id'], ['desc', 'asc'])
      .groupBy(reportModule.reportSorting)
      .toPairs()
      .map(data => {
        return _.zipObject([reportModule.reportSorting, 'reports'], data);
      });

    if (reportModule.reportSorting !== 'goalId') {
      return reportData
        .sort((a, b) => {
          return (
            new Date(b[reportModule.reportSorting] as string).getTime() -
            new Date(a[reportModule.reportSorting] as string).getTime()
          );
        })
        .value();
    } else {
      return reportData
        .sort((a, b) => {
          if (a['reports'][0]['goalYear'] === b['reports'][0]['goalYear']) {
            return (
              (+b['reports'][0]['goalId'] || -1) -
              (+a['reports'][0]['goalId'] || -1)
            );
          }
          return (
            (+b['reports'][0]['goalYear'] || -1) -
            (+a['reports'][0]['goalYear'] || -1)
          );
        })
        .value();
    }
  }

  get reportIndividualData() {
    return reportModule.reportIndividualData;
  }

  get reportDataDetail() {
    return this.reportIndividualData?.data;
  }

  get reportSorting() {
    return reportModule.reportSorting
  }

  get filterGroupReport() {
    if (reportModule.reportSorting === 'goalId' &&
      reportModule.reportCoachClientCompanyName &&
      reportModule.reportCoachClientType
    ) {
      const params: any = {
        [reportModule.reportCoachClientType as string]:
          reportModule.reportCoachClientCompanyName as string,
        coachId: reportViewModel.coachId,
      }
      goalModule
        .loadGoals(params)
        .then(
          () => {
            const goalData = {}
            goalModule.goalData.forEach(item => {
              goalData[item['id']] = item['percentCompleted']
            })
            this.goalData = goalData
          }
        );
    }
    const filterData = _.chain(this.reportDataDetail)
      .map(data => {
        return {
          id: `${data['id']}__${_.uniqueId('report_')}`,
          coachClientId: data['coachClientId'],
          created: dateFilter2(data['created']),
          fullCreated: data['created'],
          name: `${data['coachClient']['firstName']} ${data['coachClient']['lastName']}`,
          message: data['message'],
          updated: dateFilter2(data['updated']) || 'Updated #',
          fullUpdated: data['updated'] || 'Updated #',
          points: data['points'],
          goalId: data['goalId'] || '#',
          goalYear: data['goal']['year'] || '',
          goalContent: data['goal']['content'] || '',
          companyName: data['coachClient']['companyName'],
          department: data['coachClient']['department'],
        };
      })
      .filter(rp => (rp.companyName === reportModule.reportCoachClientCompanyName || rp.department === reportModule.reportCoachClientCompanyName))
      .orderBy(['name'], ['asc'])
      .groupBy('name')
      .toPairs()
      .value()

    return filterData
  }

  get reportCoachClientCompanyName() {
    return reportModule.reportCoachClientCompanyName
  }

  mounted() {
    reportViewModel.loadReportParams()
  }
}
